import React, { useEffect, useState } from "react";
import { DashboardLayout } from "src/components/dashboard";
import searchIcon from "src/assets/images/input/searchIcon.svg";
import { Input } from "src/components/inputs";
import { Loader } from "src/components/common";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Flex } from "src/components/ui";
import { formatDateDmy } from "src/utils";
import DisputeTabs from "src/components/dispute/DisputeTab";
import { useGetAllDisputesQuery } from "src/store/services/disputeApi";
import { PaginationProps } from "src/components/ui/Pagination";

interface Props {
  handleChange: (e: any) => void;
}

interface user {
  first_name: string;
  last_name: string;
  display_picture: string;
}

interface booking_info {
  user: user;
}

interface DisputeTypes {
  id: number;
  description: string;
  booking_id: string;
  createdAt: string;
  display_picture: string;
  status: string;
  booking_info: booking_info;
  sender: string;
}

export const RhsHeading: React.FC<Props> = ({ handleChange }) => (
  <Input
    icon={<img src={searchIcon} alt="searchIcon" />}
    type="search"
    placeholder="Search"
    handleChange={handleChange}
  />
);

const DisputePage = () => {
  const [searchField, setSearchField] = useState("");
  const [disputeData, setDisputeData] = useState<DisputeTypes[]>([
    {} as DisputeTypes,
  ]);

  const [paginationData, setPaginationData] = useState<PaginationProps>({
    page: 0,
    pageSize: 0,
    total: 0,
    totalPages: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Dispute Page";
  }, []);

  const [page, setPage] = useState(1);

  const { data: disputesResp, isLoading: isLoadingDisputes } =
    useGetAllDisputesQuery({ page, limit: 10, search: searchField });
  useEffect(() => {
    const rows: any[] = disputesResp?.payload?.data || [];
    const pagination = disputesResp?.payload?.pagination;
    setDisputeData(rows as any);
    if (pagination) setPaginationData(pagination);
  }, [disputesResp]);
  const handleChange = (e: any) => {
    setSearchField(e.target.value);
  };
  let [searchParams, setSearchParams] = useSearchParams();

  const filteredData = disputeData.filter((data) => {
    // console.log(data.description);
    if (data.description) {
      return data.description.toLowerCase().includes(searchField.toLowerCase());
    }
  });

  const handleNavigate = (row: { [x: string]: any }) => {
    navigate(`/dispute/${row?.booking_id}?tabStatus=${row?.status}`);
  };

  const DisputeTableHeaders = [
    {
      title: "User",
      render: (row: DisputeTypes) => (
        <Flex gap="10px" align="center">
          <img
            style={{ width: 40, height: 40, borderRadius: "50%" }}
            src={row.booking_info.user.display_picture}
            alt=""
          />{" "}
          <Flex gap="3px" align="start" direction="column">
            {row.booking_info.user.first_name} {row.booking_info.user.last_name}
            <p style={{ color: "#667085", fontSize: "14px" }}>{row.sender == 'artisan' ? 'Vendor' : 'Customer'}</p>
          </Flex>
        </Flex>
      ),
    },
    {
      title: "Description",
      render: (row: DisputeTypes) => `${row.description}`,
    },
    {
      title: "Date",
      render: (row: DisputeTypes) => formatDateDmy(row.createdAt),
    },
    {
      title: "Status",
      render: (row: DisputeTypes) => (
        <p
          className={`capitalize ${
            row.status === "pending" ? "text-[#55C4F1]" : "text-[#7607BD]"
          }`}
        >
          {row.status === "pending" ? "active" : row.status}
        </p>
      ),
    },
  ];

  return (
    <DashboardLayout
      pageTitle="Dispute Management"
      rhsHeading={<RhsHeading handleChange={handleChange} />}
    >
      {/* <ToastContainer /> */}
      <div>
        {isLoadingDisputes ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "100px",
            }}
          >
            <Loader>loading...</Loader>{" "}
          </div>
        ) : filteredData.length > 0 ? (
          <DisputeTabs
            rows={filteredData}
            BookingsTableHeaders={DisputeTableHeaders}
            title={
              <p className="count">
                {filteredData.length > 1 ? filteredData.length : 0} Dispute
              </p>
            }
            onRowClick={handleNavigate}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            pgn={page}
            setPgn={setPage}
            paginationData={paginationData}
          />
        ) : (
          <p className="table-entry-status">No Data Found</p>
        )}
      </div>
    </DashboardLayout>
  );
};

export default DisputePage;
